import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import {
  EXPORT_FORMATS,
  getExportActionLabel,
  getExportLoadingLabel,
} from './exportConstants';
import '../../../../../Styles/LeadershipExportDrawer.css';

const LeadershipExportDrawer = ({
  isOpen,
  onClose,
  exportConfig,
  drawerTitle,
  helperText = 'Selected charts will be exported using the current filters.',
  selectedCount,
  isSelected,
  onToggleItem,
  onSelectAll,
  onClearAll,
  onExport,
  isExporting,
}) => {
  const [exportFormat, setExportFormat] = useState(EXPORT_FORMATS.PDF);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('leadership-export-drawer-open');
    } else {
      document.body.classList.remove('leadership-export-drawer-open');
    }

    return () => {
      document.body.classList.remove('leadership-export-drawer-open');
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setExportFormat(EXPORT_FORMATS.PDF);
    }
  }, [isOpen]);

  const handleExport = () => {
    onExport(exportFormat);
  };

  const resolvedDrawerTitle = drawerTitle || exportConfig?.drawerTitle || 'Export Dashboard';

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={isExporting ? undefined : onClose}
      className="leadership-export-drawer"
      overlayClassName="leadership-export-drawer-overlay"
      contentLabel="Export Dashboard"
      ariaHideApp={false}
      shouldCloseOnOverlayClick={!isExporting}
    >
      <div className="leadership-export-drawer-header">
        <div>
          <h2 className="leadership-export-drawer-title">{resolvedDrawerTitle}</h2>
          <p className="leadership-export-drawer-helper">
            {helperText}
          </p>
        </div>
        <button
          type="button"
          className="leadership-export-drawer-close"
          onClick={onClose}
          disabled={isExporting}
          aria-label="Close export drawer"
        >
          ×
        </button>
      </div>

      <div className="leadership-export-drawer-body">
        <fieldset className="leadership-export-format">
          <legend className="leadership-export-format-label">Format</legend>
          <label className="leadership-export-format-option">
            <input
              type="radio"
              name="export-format"
              value={EXPORT_FORMATS.PDF}
              checked={exportFormat === EXPORT_FORMATS.PDF}
              onChange={() => setExportFormat(EXPORT_FORMATS.PDF)}
              disabled={isExporting}
            />
            PDF
          </label>
          <label className="leadership-export-format-option">
            <input
              type="radio"
              name="export-format"
              value={EXPORT_FORMATS.PNG}
              checked={exportFormat === EXPORT_FORMATS.PNG}
              onChange={() => setExportFormat(EXPORT_FORMATS.PNG)}
              disabled={isExporting}
            />
            Image (PNG)
          </label>
        </fieldset>

        <div className="leadership-export-selection-actions">
          <button type="button" className="leadership-export-link-btn" onClick={onSelectAll} disabled={isExporting}>
            Select All
          </button>
          <span className="leadership-export-selection-divider" aria-hidden="true">
            |
          </span>
          <button type="button" className="leadership-export-link-btn" onClick={onClearAll} disabled={isExporting}>
            Clear All
          </button>
        </div>

        <div className="leadership-export-sections">
          {exportConfig.sections.map((section) => (
            <section key={section.title} className="leadership-export-section">
              <h3 className="leadership-export-section-title">{section.title}</h3>
              <ul className="leadership-export-checklist">
                {section.items.map((item) => (
                  <li key={item.id}>
                    <label className="leadership-export-check-item">
                      <input
                        type="checkbox"
                        checked={isSelected(item.id)}
                        onChange={() => onToggleItem(item.id)}
                        disabled={isExporting}
                      />
                      <span>{item.label}</span>
                    </label>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>

      <div className="leadership-export-drawer-footer">
        <button
          type="button"
          className="leadership-export-cancel-btn"
          onClick={onClose}
          disabled={isExporting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="leadership-export-submit-btn"
          onClick={handleExport}
          disabled={isExporting || selectedCount === 0}
        >
          {getExportActionLabel(exportFormat, isExporting)}
        </button>
      </div>

      {isExporting && (
        <div className="leadership-export-loading-overlay" role="status" aria-live="polite">
          {getExportLoadingLabel(exportFormat)}
        </div>
      )}
    </Modal>
  );
};

export default LeadershipExportDrawer;
